import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

interface CardNewsProps {
    foto: string;
    width: string;
    indirizzo: string;
    settore1?: string;
    settore2?: string;
    posizioneFoto: string;
}

function CardNewsEvidenzaFoto({ foto, width, indirizzo, settore1, settore2, posizioneFoto }: CardNewsProps) {
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);

    return (
        <div
            className="card"
            style={{
                minWidth: "12em",
                border: "solid 5px #032041",
                borderRadius: "12px",
                padding: "0em",
                margin: "0 1em 1em 1em",
                backgroundColor: isHovered ? "#447aa0" : "transparent",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                cursor: "pointer",
                position: "relative"
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={() => navigate(`${indirizzo}`)}
        >
            <div style={{ width: "100%", position: "relative" }}>
                <img
                    src={foto}
                    className="card-img-top m-auto"
                    alt="news"
                    style={{
                        width: "100%",
                        height: "auto",
                        aspectRatio: "2300/1600",
                        objectFit: "cover",
                        objectPosition: posizioneFoto
                    }}
                />
            </div>
            <div className="card-footer"
                 style={{
                     width: "100%",
                     height: "100%",
                     backgroundColor: "#032041",
                     color: "white",
                     minHeight: "1.5em",
                     padding: "0.1em",
                     textAlign: "center",
                     display: "flex",
                     justifyContent: "center",
                     gap: "5px"
                 }}>
                {settore1 && <NavLink to={`/${settore1}`} style={{ color: "white" }}>{settore1}</NavLink>}
                {settore2 && <NavLink to={`/${settore2}`} style={{ color: "white" }}>{settore2}</NavLink>}
            </div>
        </div>
    );
}

export default CardNewsEvidenzaFoto;
